import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("h3", null, "Are you happy to submit the form?", -1);
const _hoisted_4 = /*#__PURE__*/ _createElementVNode("p", null, "If you are happy all the information you have provided is correct, please click the button to submit the form", -1);
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", { class: "text-red-700" }, "If applicable, please ensure your leaver downloads all of their payslips before they leave", -1);
const _hoisted_6 = { class: "flex justify-end" };
const _hoisted_7 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createTextVNode(),
            _hoisted_4,
            _createTextVNode(),
            _hoisted_5,
            _createTextVNode(),
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("button", {
                    disabled: _ctx.disableButton,
                    class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                    onClick: _cache[0] || (_cache[0] = _withModifiers(
                    //@ts-ignore
                    (...args) => (_ctx.handleSumitLeaver && _ctx.handleSumitLeaver(...args)), ["prevent"]))
                }, "Submit", 8, _hoisted_7)
            ])
        ])
    ]));
}
